<template>
  <div class="user-org-users-control_usc org-admin_oam" :class="{ [curTheme]: true }">

    <page-header>
      <nav-inner :use-user-links="true"/>
    </page-header>
    <nav-user-orgs/>

    <div class="page-container_pcr">
      <h2 class="oam_page-title">Пользователи организации</h2>
    </div>

    <nav-user-org-page/>

    <div class="page-container_pcr">

      <h3 class="oam_inner-title">Работа с пользователями</h3>

    </div>

    <div class="page-container_pcr">

      <div
        v-if="$store.getters['user/isSysAdmin']"
        class="oam_filter_oaf"
        style="margin-bottom: 35px">
        <div class="oaf_cells oaf_cells-2">
          <div class="oaf_cell text-center" style="padding-bottom: 0">
            <button
              @click="fetchData(false, true)"
              class="normal-button"
              :class="{ 'normal-button--on': !showAllUsers }"
              style="width: 100%">
              Пользователи организации</button>
          </div>
          <div class="oaf_cell text-center" style="padding-bottom: 0">
            <button
              @click="fetchData(true, true)"
              class="normal-button"
              :class="{ 'normal-button--on': showAllUsers }"
              style="width: 100%">
              Все пользователи платформы</button>
          </div>
        </div>
      </div>

      <div class="oam_filter_oaf">
        <div class="oaf_cells oaf_cells-1">
          <div class="oaf_cell">
            <div class="oaf_label">Отправить сообщение пользователям на e-mail</div>
            <el-input
              type="textarea"
              :rows="2"
              :autosize="{ minRows: 2 }"
              class="usc_msg"
              placeholder="Введите текст сообщения..."
              v-model="msg"/>
          </div>
        </div>
        <div class="oaf_submits">
          <button @click="sendMsg(true)" class="usc_msg-btn lite-button">
            Отправить выбранным</button>
          <button @click="sendMsg()" class="usc_msg-btn lite-button">
            Отправить всем</button>
        </div>
      </div>

      <el-pagination
        v-show="pager.total > pager.pageSize"
        :page-size="pager.pageSize"
        :total="pager.total"
        :current-page.sync="pager.curPage"
        @current-change="pagerClicked"
        layout="prev, pager, next, jumper"/>

      <div class="data-table_dta" v-if="tableData && tableData.length">
        <table>
          <thead>
          <tr>
            <th>№</th>
            <th>
              <template v-if="usersPickedIds && usersPickedIds.length > 0">
                <el-checkbox
                  :value="true"
                  class="usc_cbox"
                  @change="onControlCboxChange"/>
              </template>
            </th>
            <th>Пользователь</th>
            <th>Подразделение</th>
            <th>Должность</th>
            <th>Репутация</th>
            <th>Баллы</th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="(o, i) in tableData" :key="`row-${i}`">
              <td class="text-center">
                {{ ((pager.curPage - 1 ) * pager.pageSize) + i + 1 }}</td>
              <td>
                <el-checkbox
                  :value="isPicked(o)"
                  class="usc_cbox"
                  @change="onCboxChange(o)"/>
              </td>
              <td><a :href="`/user/${o.UserId}/profile/view`" target="_blank">
                {{ fio(o) }}</a></td>
              <td class="text-center">
                {{ Array.isArray(o.Jobs) ? o.Jobs[0].Department : '' }}</td>
              <td class="text-center">
                {{ Array.isArray(o.Jobs) ? o.Jobs[0].Post : '' }}</td>
              <td class="text-center">{{ round(o.Transient.Reputation) }}</td>
              <td class="text-center">{{ round(o.Transient.Score) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <el-pagination
        v-show="pager.total > pager.pageSize"
        :page-size="pager.pageSize"
        :total="pager.total"
        :current-page.sync="pager.curPage"
        @current-change="pagerClicked"
        layout="prev, pager, next, jumper"/>

    </div>

    <page-footer/>

  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import OrgAdminLayoutMixin from '@/components/layouts/org-admin/UserOrgLayoutMixin';

export default {

  mixins: [OrgAdminLayoutMixin],

  data() {
    return {
      usersPickedIds: [],
      msg: '',
      // Whether to show all users of IPU if true
      // or only users of current org if false
      showAllUsers: false,
      filterDefaults: {
        limit: 20,
        offset: 0,
      },
    };
  },

  mounted() {
    this.$nextTick(this.fetchData);
  },

  methods: {

    onControlCboxChange() {
      this.usersPickedIds = [];
    },

    pagerClicked() {
      this.fetchData(this.showAllUsers);
    },

    sendMsg(pickedOnly) {
      if (!this.msg) {
        this.$notify.error('Введите текст сообщения.');
        return;
      }
      const params = { msg: this.msg, org_id: this.$route.params.orgId };
      if (pickedOnly) {
        if (this.usersPickedIds.length === 0) {
          this.$notify.error('Вы не выбрали ни одного пользователя.');
          return;
        }
        params.ids = this.usersPickedIds;
      }
      Vue.$loading.on();
      axios.post('users/send-mail', params).then((r) => {
        Vue.$loading.off();
        this.$message.success(r.data);
      }).catch((err) => {
        Vue.$loading.off();
        this.$notify.error(err.response.data);
      });
    },

    fetchData(showAllUsers = false, fromStart = false) {
      if (typeof showAllUsers === 'undefined') {
        this.showAllUsers = false;
      } else {
        this.showAllUsers = showAllUsers;
      }
      if (fromStart) {
        this.pager.curPage = 1;
      }

      const orgId = this.$route.params.orgId;
      if (!orgId) {
        this.$notify.error('Не удалось определить организацию.');
        return;
      }

      Vue.$loading.on();
      let params = this.getParams();
      if (this.showAllUsers === false) {
        params += `&organization=${this.$route.params.orgId}`;
      }
      axios.get(`users/rating?${params}`).then((r) => {
        this.tableData = r.data.Users;
        this.pager.total = r.data.Found;
        Vue.$loading.off();
        this.$forceUpdate();
      }).catch(() => {
        this.tableData = [];
        this.$notify.error('Ошибка при получении списка пользователей.');
        Vue.$loading.off();
      });
    },

    onCboxChange(o) {
      const i = this.usersPickedIds.indexOf(o.UserId);
      if (i === -1) {
        this.usersPickedIds.push(o.UserId);
      } else {
        this.usersPickedIds.splice(i, 1);
      }
    },

    isPicked(o) {
      return this.usersPickedIds.indexOf(o.UserId) > -1;
    },

  },

};
</script>

<style lang="scss">
@import "../../../styles/components/org-admin/common";

.user-org-users-control_usc {
  .usc_cbox {
    .el-checkbox__inner:hover,
    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: $color-1;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: $color-1;
      border-color: $color-1;
    }
  }
  .usc_msg {
    border-color: $color-2;
  }
  .oaf_submits {
    margin-top: 10px !important;
  }
  .usc_msg-btn {
    margin: 10px;
    width: 210px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/org-admin/UserOrgUsersList.vue